import { useTranslation } from "react-i18next";
import React, { useContext } from "react";
import { useNavigate } from 'react-router-dom'
import { useState } from 'react';
import { AppContext } from '../App';
import axios from 'axios';
import Swal from 'sweetalert2'

const Login = () => {
    const { t, i18n  } = useTranslation();
    const { locale, setLocale } = useState("en")
    const { sysConfig } = useContext(AppContext) 
    const { sysName } = useContext(AppContext)
    const { sysToken,loading, showLoading, isLogin, setIsLogin } = useContext(AppContext)
    // test
    // const posts = [
    //     {id: 1, title: 'Hello World', content: 'Welcome to learning React!'},
    //     {id: 2, title: 'Installation', content: 'You can install React from npm.'}
    //   ]
    // const arr = [1,2,5,3]
    // const res = posts.map(posts =>
    //         <div key={posts.id}>{posts.title}</div>
    //     )
    // return res

    // 使用 hook
    const navigate = useNavigate();    
    const [userid, setUserId] = useState();
    const [password, setPassword] = useState();

    function parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
    }

    function chgLang(e) {
        e.preventDefault()
        i18n.changeLanguage("en")
    }
    const checkAuth = (e) => {
        e.preventDefault()
        const gId = 'admin'
        const gPw = 'aa'
        const gToken = 'xxx-123-xxx'
        console.log(userid, password)

        if(typeof(userid) == 'undefined' || userid.trim() == '') {
            Swal.fire({
                title: '請輸入名稱',     
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: '確定'
              })
              return
        }
        if(typeof(password) == 'undefined' || password.trim() == '') {
            Swal.fire({
                title: '請輸入密碼',     
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: '確定'
              })
              return
        }

        //localStorage.setItem("token", gToken)  
        //return navigate("/")
        //return navigate("/")
        // api
        
        //const apiUrl = 'http://localhost:3000/data/auth.json'   
        showLoading(true)     
        const apiUrl =  sysConfig.apiUrl + 'Auth/Token'
        axios.post(apiUrl, { uId: userid, uPw: password }).then((response) => {
            console.log(response.data)

            if(response.data.code == '200') 
            {
                const gToken = response.data.tnToken.tokenStr;
                //sysToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.7TR46yjtYRpSTwWwamhRefiKp5vYqfVqNbEAqJUgCl0'
                
                axios.defaults.headers.common["Authorization"] = `${gToken}`;

                const authObj = parseJwt(gToken)
                const authInfo = JSON.parse(authObj.AuthInfo)

                localStorage.setItem("token", gToken)   

                var roleids = ''
                authInfo.User.RoleList.forEach(item => {
                    roleids += item.Id + ','
                })

                localStorage.setItem("role", roleids)   
                localStorage.setItem("userId", authInfo.User.Id)  
                localStorage.setItem("LoginId", authInfo.User.LoginId)    
                localStorage.setItem("userName", authInfo.User.Username)   
                setIsLogin(true)

                //return navigate("/")
                window.location.href = '/'
            }
            else {
                Swal.fire({
                    title: '驗證失敗',     
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: '確定'
                  })
            }
            showLoading(false)
        });

        // axios
        // .post(apiUrl, {
        //     title: "Hello World!",
        //     body: "This is a new post."
        // })
        // .then((response) => {
        //     console.log(response.data);
        // });

        
    }

    function keyEvent(event) {
        if (event.charCode === 13) {
            checkAuth()    
        }
        
    }

    // return <div>
    //             <div>帳號</div>
    //             <div><input key="gId"   type="text" onChange={e => setUserName(e.target.value)}></input></div>
    //             <div>密碼</div>
    //             <div><input key="gPw"   type="password" onKeyPress={keyEvent} onChange={e => setPassword(e.target.value)}></input></div>
    //             <div>
    //                 <button onClick={checkAuth}>登入</button>
    //             </div>
    //         </div>

    const cardBody = (
        <>
                <div className="pt-4 pb-2">
                    <h5 className="card-title text-center pb-0 fs-4">{t("login_01")}</h5>
                    <p className="text-center small">{t("login_02")}</p>
                  </div>
                  <form className="row g-3 needs-validation" >

                    <div className="col-12">
                      <label  className="form-label" >{t("login_03")}</label>
                      <input type="text" name="username" className="form-control" id="p_id" onChange={e => setUserId(e.target.value)} placeholder="帳號" required/>                      
                    </div>

                    <div className="col-12">
                      <label  className="form-label">{t("login_04")}</label>
                      <input type="password" name="password" className="form-control" id="p_pw" onChange={e => setPassword(e.target.value)} placeholder="密碼" required/>                      
                    </div>

                    {/* <div className="col-12">
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" name="remember" value="true" id="rememberMe"/>
                        <label className="form-check-label" >Remember me</label>
                      </div>
                    </div> */}
                    <div className="col-12">
                      <button className="btn btn-primary w-100" onClick={checkAuth}>{t("login_01")}</button>                     
                    </div>
                    {/* <div className="col-12">
                      <p className="small mb-0">Don't have account? <a href="pages-register.html">Create an account</a></p>
                    </div> */}
                  </form>
                  <div className="breadcrumb-item text-center p-2">
                    <a class="" href="/" >{t("login_05")}</a>
                  </div>
                  
        </>
    )

    const card = (
        <div className="card mb-3 card-login login-block-card">
            <div className="card-body">
                {cardBody}
            </div>
        </div>
    )

    const container = (
        <div className="container">
            <div className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                            {card}
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    )

    const loadDiv = (
        loading == true ?
        <div className="overlay">
              <div className="overlay__inner">
                  <div className="overlay__content"><span className="spinner"></span></div>
              </div>
          </div>
          :
          <div></div>
      )

    return (
        <>
        {loadDiv}
        {container}
        </>
    )
  }

 export default Login

// export default() => (
//     <div>
//         <div>帳號</div>
//         <div><input type="text"></input></div>
//         <div>密碼</div>
//         <div><input type="password"></input></div>
//         <div>
//             <button>登入</button>
//         </div>
//     </div>
// )